import type { User } from "src/types/user";
import type { DatabaseData } from "./databaseData";
import type { Organization } from "./organization";
import type { Pos } from "./pos";

export enum PosGroupStatus {
    activated = "activated",
    archived = "archived",
}

export enum PosGroupKeys {
    id = "id",
    name = "name",
    poss = "poss",
    organization = "organization",
    status = "status",
    createdDateUTC = "createdDateUTC",
}

export interface PosGroup extends DatabaseData {
    name: string;
    poss: Pos[];
    organization: Organization;
    organizationId?: number;
    status: PosGroupStatus;
    createdDateUTC: Date;
    users?: User[];
    usersId?: number[];
}
